import { render } from "./cartboard.vue?vue&type=template&id=1348ba33&scoped=true"
import script from "./cartboard.vue?vue&type=script&lang=js"
export * from "./cartboard.vue?vue&type=script&lang=js"

import "./cartboard.vue?vue&type=style&index=0&id=1348ba33&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1348ba33"]])

export default __exports__